import { Button, Form, Input, Modal } from 'antd';
import React from 'react';

const DetectionTypeOtherModal = ({
  visible,
  setVisible,
  setDetectionTypeOther,
}) => {
  const [form] = Form?.useForm();
  const onFinish = (value) => {
    setDetectionTypeOther(value?.type);
    setVisible(false);
  };
  return (
    <Modal
      destroyOnClose
      className="modal-components-design"
      title="Type - Other"
      open={visible}
      onCancel={setVisible}
      footer={null}
      centered
    >
      <Form
        name="videoModal"
        onFinish={onFinish}
        className="custom-label"
        form={form}
        layout="vertical"
      >
        <Form.Item
          label="Type"
          name="type"
          rules={[
            {
              required: true,
              message: 'Please type category',
            },
          ]}
        >
          <Input placeholder="Enter type here" maxLength={100} />
        </Form.Item>
        <Form.Item shouldUpdate>
          {({ isFieldsTouched, getFieldsError }) => (
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              block
              disabled={
                !isFieldsTouched(['type'], true) ||
                !!getFieldsError()?.filter(({ errors }) => errors?.length)
                  .length
              }
            >
              Submit
            </Button>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DetectionTypeOtherModal;
